import React, { createContext, useCallback, useState } from 'react';
import { useAsyncEffect, useAsyncState, wrap } from '@hilma/tools';

import { useGLanguage } from '../hooks';

export const IsGoogleMapsLoadingContext = createContext<boolean | null>(null);
export const RunGoogleMapsEffectContext = createContext<(() => void) | null>(null);

const GoogleMapsProvider: React.FC = ({ children }) => {

    const [isLoading, setIsLoading] = useAsyncState(true);
    const [runEffect, setRunEffect] = useState(false);

    const language = useGLanguage();

    const runMapsEffect = useCallback(() => {
        setRunEffect(true);
    }, []);

    useAsyncEffect(async () => {
        if (!runEffect ||
            typeof window === 'undefined' ||
            !document.querySelector('head') ||
            document.querySelector('#google-maps')
        ) return;

        await setIsLoading(true);

        const script = document.createElement('script');
        script.setAttribute('async', '');
        script.setAttribute('id', 'google-maps');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_MAPS_KEY}&language=${language}&region=IL&libraries=places`;
        script.type = 'text/javascript';
        document.querySelector('head')!.appendChild(script);
        script.onload = () => {
            setIsLoading(false);
        };

        return () => {
            (window.google as typeof google | undefined) = undefined;

            const scripts = document.head.getElementsByTagName("script");
            const script = scripts.namedItem('google-maps');
            script?.remove();
        }

    }, [language, runEffect]);

    return wrap(
        [RunGoogleMapsEffectContext.Provider, { value: runMapsEffect }],
        [IsGoogleMapsLoadingContext.Provider, { value: isLoading }]
    )(children) as React.ReactElement;
}

export default GoogleMapsProvider;